import React from 'react';

const EmailValidationIcon = (props: any) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M18.72 12.5068V5.79736" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13.92 16.3466H4.32C3.2592 16.3466 2.4 15.4874 2.4 14.4266V5.78662"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7894 3.8667H4.33056C3.264 3.8667 2.4 4.7307 2.4 5.79726V5.79726C2.4 6.43758 2.71776 7.03566 3.24768 7.3947L8.3904 10.8805C9.7008 11.7685 11.4211 11.7685 12.7315 10.8805L17.8733 7.39566C18.4022 7.03662 18.72 6.43758 18.72 5.79822V5.79726C18.72 4.7307 17.856 3.8667 16.7894 3.8667V3.8667Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4749 13.632C21.9744 15.1315 21.9744 17.5632 20.4749 19.0627C18.9754 20.5622 16.5437 20.5622 15.0442 19.0627C13.5446 17.5632 13.5446 15.1315 15.0442 13.632C16.5437 12.1324 18.9754 12.1324 20.4749 13.632"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2528 15.5996L17.3856 17.4668L16.2662 16.3465"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EmailValidationIcon;
